module.exports = __webpack_public_path__ + "img/lens-174-plus-02.afe66275.png";